/* eslint-disable prefer-destructuring */
export const FIREBASE_CONFIG = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

export const GRAPHQL_ENDPOINT = process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT;
export const GRAPHQL_WS_ENDPOINT = process.env.NEXT_PUBLIC_GRAPHQL_WS_ENDPOINT;

export const NEXT_PUBLIC_SENTRY_SERVER_ROOT_DIR = process.env.NEXT_PUBLIC_SENTRY_SERVER_ROOT_DIR;
export const NEXT_PUBLIC_SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;

export const SUBJECT_COLORS = [
  '#F44336',
  '#E44442',
  '#D3464D',
  '#C34759',
  '#B24864',
  '#A24970',
  '#914B7B',
  '#814C87',
  '#704D92',
  '#604E9E',
  '#4F50A9',
  '#3F51B5',
  '#2196F3',
  '#1E96E9',
  '#1B96E0',
  '#1896D6',
  '#1596CC',
  '#1296C2',
  '#0F96B9',
  '#0C96AF',
  '#0996A5',
  '#06969B',
  '#039692',
  '#009688',
  '#4CAF50',
  '#5CA74C',
  '#6D9F48',
  '#7D9743',
  '#8D8F3F',
  '#9D873B',
  '#AE7F37',
  '#BE7733',
  '#CE6F2F',
  '#DE672A',
  '#EF5F26',
  '#FF5722',
  '#ffab00',
  '#ff9100',
  '#f57c00',
  '#ef6c00',
];
